// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetLectureLessonStatesRequestModel from '../../model/get-lecture-lesson-states-request-model';
import GetLectureLessonStatesRequestDTO from '../dto/get-lecture-lesson-states-request-dto';
import dtoSchema from '../schemas/get-lecture-lesson-states-request-schema';

export default abstract class GetLectureLessonStatesRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetLectureLessonStatesRequestDTO>) {
    super();
  }

  static toModel(dto: DeepPartial<GetLectureLessonStatesRequestDTO>): GetLectureLessonStatesRequestModel;
  static toModel(dto: DeepPartial<GetLectureLessonStatesRequestDTO> | undefined | null): GetLectureLessonStatesRequestModel | undefined;
  static toModel(dto: DeepPartial<GetLectureLessonStatesRequestDTO> | undefined | null): GetLectureLessonStatesRequestModel | undefined {
    return dto ? new GetLectureLessonStatesRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetLectureLessonStatesRequestModel> | GetLectureLessonStatesRequestModel): GetLectureLessonStatesRequestDTO {
    const dto = {
    } as GetLectureLessonStatesRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetLectureLessonStatesRequestModel, can not map to GetLectureLessonStatesRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
